import React from 'react'

function StarsP() {
  return (
    <svg width="41" height="36" viewBox="0 0 41 36" fill="none" xmlns="http://www.w3.org/2000/svg" className='c-2__stars'>
        <line x1="11.7509" y1="11.2505" x2="11.7509" y2="36.0004" stroke="white"/>
        <line x1="24.7499" y1="23.001" x2="1.52588e-05" y2="23.001" stroke="white"/>
        <line x1="32.4081" y1="-2.05701e-08" x2="32.4081" y2="15.7499" stroke="white"/>
        <line x1="40.4999" y1="7.65869" x2="24.75" y2="7.65869" stroke="white"/>
    </svg>
  )
}

export default StarsP